// -----------------------------------------------------------------------------
// Script for contact form subject
// -----------------------------------------------------------------------------

function subjectForm() {


  // Trip list
  var tripList = $('.form__trip-list-wrapper').html();
  $('.form__trip-list').html(tripList);

  $('input[name="trip-name"]').attr('readonly', true);

  $('.form__trip-content').on('click', function () {
    $('.form__trip-list').slideToggle('slow');
  });

  $('.form__trip-item').on('click', function () {
    var valueTrip = $(this).text();
    var linkTrip = $(this).attr('data-trip-name');

    $('input[name="trip-name"]').val(valueTrip);
    $('input[name="trip-name"]').attr('readonly', true);
    $('input[name="trip-name"]').attr('placeholder', '');
    $('.form__trip-select').remove();
    $('.form__btn-detail-wrapper').fadeIn('slow');
    $('.form__btn--detail').attr('href', linkTrip);

    $('.form__trip-list').slideUp('slow');
  });

  $('body').on('click', function (e) {
    if (!$('.form__trip-content').is(e.target) && ($('.form__trip-content').has(e.target).length === 0)) {
      $('.form__trip-list').slideUp('slow');
    }
  });


  // Meeting list
  var meetList = $('.form__trade-list-wrapper').html();
  $('.form__trade-list').prepend(meetList);

  $('input[name="trade-name"]').attr('readonly', true);

  $('.form__trade-content').on('click', function () {
    $('.form__trade-list').slideToggle('slow');
  });

  $('.form__trade-item').on('click', function () {
    var valueTrade = $(this).text();

    if ($(this).hasClass('form__trade-item-last')) {
      $('input[name="trade-name"]').val('');
      $('input[name="trade-name"]').attr('readonly', false);
      $('input[name="trade-name"]').attr('placeholder', valueTrade);
      $('.form__trade-select').hide();
    } else {
      $('input[name="trade-name"]').val(valueTrade);
      $('input[name="trade-name"]').attr('readonly', true);
      $('input[name="trade-name"]').attr('placeholder', '');
      $('.form__trade-select').hide();
    }

    $('.form__trade-list').slideUp('slow');
  });

  $('body').on('click', function (e) {
    if (!$('.form__trade-content').is(e.target) && ($('.form__trade-content').has(e.target).length === 0)) {
      $('.form__trade-list').slideUp('slow');
    }
  });



  // Subject selection
  $('input[name="page-subject"]').attr('readonly', true);

  $('.form__subject-content').on('click', function () {
    $('.form__subject-list').slideToggle('slow');
  });

  $('body').on('click', function (e) {
    if (!$('.form__subject-content').is(e.target) && ($('.form__subject-content').has(e.target).length === 0)) {
      $('.form__subject-list').slideUp('slow');
    }
  });

  $('.form__subject-item').on('click', function () {
    var valueSubject = $(this).text();
    $('input[name="page-subject"]').val('');
    $('input[name="page-subject"]').attr('placeholder', '');
    $('.form__subject-select').hide();
    $('.form__trip').fadeOut('slow');
    $('.form__trade').fadeOut('slow');
    $('.form__btn-detail-wrapper').fadeOut('slow');

    if ($(this).hasClass('form__subject-item1')) {
      $('input[name="page-subject"]').val('');
      $('input[name="page-subject"]').attr('readonly', false);
      $('input[name="page-subject"]').attr('placeholder', valueSubject);
    } else if ($(this).hasClass('form__subject-item2')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('readonly', true);
      $('input[name="page-subject"]').attr('placeholder', '');
    } else if ($(this).hasClass('form__subject-item3')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('placeholder', '');
      $('input[name="page-subject"]').attr('readonly', true);
      $('#contact-form').css('maxHeight','none');
      $('.form__trip').fadeIn('slow');
    } else if ($(this).hasClass('form__subject-item4')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('readonly', true);
      $('input[name="page-subject"]').attr('placeholder', '');
    } else if ($(this).hasClass('form__subject-item5')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('placeholder', '');
      $('input[name="page-subject"]').attr('readonly', true);
      $('#contact-form').css('maxHeight','none');
      $('.form__trade').fadeIn('slow');
    } else if ($(this).hasClass('form__subject-item6')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('readonly', true);
      $('input[name="page-subject"]').attr('placeholder', '');
    } else if ($(this).hasClass('form__subject-item7')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('readonly', true);
      $('input[name="page-subject"]').attr('placeholder', '');
    } else if ($(this).hasClass('form__subject-item8')) {
      $('input[name="page-subject"]').val(valueSubject);
      $('input[name="page-subject"]').attr('readonly', true);
      $('input[name="page-subject"]').attr('placeholder', '');
    }

    $('.form__subject-list').slideUp('slow');
  });


  // Subject depend the page
  if ($('.contact-form-subject').hasClass('form-page-offers')) {
    var valueSubject3 = $('.form__subject-item3').text();
    $('input[name="page-subject"]').val(valueSubject3);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('input[name="page-subject"]').attr('readonly', true);
    $('.form__subject-select').hide();
    $('.form__trip').fadeIn('slow');
    $('#contact-form').css('maxHeight','none');
  } else if ($('.contact-form-subject').hasClass('form-page-trip')) {
    var valueSubject7 = $('.form-page-trip').text();
    $('.form__subject-item7').text(valueSubject7);
    $('.form__subject-item7').fadeIn();
    $('input[name="page-subject"]').val(valueSubject7);
    $('input[name="page-subject"]').attr('readonly', true);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('.form__subject-select').hide();
  } else if ($('.contact-form-subject').hasClass('form-page-cooperation')) {
    var valueSubject4 = $('.form__subject-item4').text();
    $('input[name="page-subject"]').val(valueSubject4);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('input[name="page-subject"]').attr('readonly', true);
    $('.form__subject-select').hide();
  } else if ($('.contact-form-subject').hasClass('form-page-trade')) {
    var valueSubject5 = $('.form__subject-item5').text();
    $('input[name="page-subject"]').val(valueSubject5);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('input[name="page-subject"]').attr('readonly', true);
    $('.form__subject-select').hide();
    $('.form__trade').fadeIn('slow');
    $('#contact-form').css('maxHeight','none');
  }

  $('.coo-cta__btn').on('click', function () {
    var valueSubject8 = $(this).text();
    $('.form__subject-item8').text(valueSubject8);
    $('.form__subject-item8').fadeIn();
    $('input[name="page-subject"]').val(valueSubject8);
    $('input[name="page-subject"]').attr('readonly', true);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('.form__subject-select').hide();
  });


  // Trade fairs subject
  $('.trade-card__btn').on('click', function () {
    var valueTrade = $(this).parents('.trade-card').find('.trade-card__title strong').text();
    $('input[name="page-subject"]').val(valueTrade);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('input[name="page-subject"]').attr('readonly', true);
    $('.form__trip').fadeOut('slow');
    $('.form__trade').fadeOut('slow');
    $('.form__btn-detail-wrapper').fadeOut('slow');
    $('.form__subject-select').hide();
  });

  $('.trade-fairs__cta-btn').on('click', function () {
    var valueSubject5 = $('.form__subject-item5').text();
    $('input[name="page-subject"]').val(valueSubject5);
    $('input[name="page-subject"]').attr('placeholder', '');
    $('input[name="page-subject"]').attr('readonly', true);
    $('.form__subject-select').hide();
    $('.form__trade').fadeIn('slow');
    $('.form__trade-select').show();
    $('input[name="trade-name"]').val('');
  })

}